/**
 * VueAdjacentHTML
 * ディレクティブ対象を、引数のHTMLで置換します。（HTML String to DOM）
 */
import directive from './directive'

const VueAHTML = {
  install: function(Vue, options) {

    Vue.directive('ahtml', directive);
  }
}
export default VueAHTML



// WEBPACK FOOTER //
// ./src/plugins/vue-ahtml/index.js